<h2 mat-dialog-title>Set Authentication Credentials</h2>
<form [formGroup]="authForm" (ngSubmit)="onSubmit()">
  <mat-dialog-content>
    <mat-form-field appearance="fill">
      <mat-label>Username</mat-label>
      <input matInput formControlName="username" required />
    </mat-form-field>

    <mat-form-field appearance="fill">
      <mat-label>Password</mat-label>
      <input matInput formControlName="password" type="password" required />
    </mat-form-field>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Cancel</button>
    <button mat-button color="primary" type="submit" [disabled]="authForm.invalid">
      Save
    </button>
  </mat-dialog-actions>
</form>
